import html from '../../assets/cert/html.png';
import javascript from '../../assets/cert/javascript.png';
import react from '../../assets/cert/react.png';
import ruby from '../../assets/cert/ruby.png';
import rails from '../../assets/cert/rails.png';
import js from '../../assets/cert/js.png';
import sql from '../../assets/cert/sql.png';
import capstone from '../../assets/cert/capstone.png';
import { v4 as Id } from 'uuid';
const CertData = [
  {
    id: Id(),
    img:html,
    name:"HTML & CSS",
    live:"https://www.credential.net/0f125ed5-fd4a-41a3-9ac9-6024a3bff52e",
  },
  {
    id: Id(),
    img:javascript,
    name:"Javascript",
    live:"https://www.credential.net/1dd02c7d-f10c-4893-858d-2ba49df596ea",
  },
  {
    id: Id(),
    img:react,
    name:"React and Redux",
    live:"https://www.credential.net/979d2c6d-fb20-4508-8b82-ba2a97462636",
  },
  {
    id: Id(),
    img:ruby,
    name:"Ruby and Database",
    live:"https://www.credential.net/1d308a0e-4704-4f66-91b9-58f6c639c1d0#gs.0ik94w"
  },
  {
    id: Id(),
    img:rails,
    name:"Ruby on Rails",
    live:"https://www.credential.net/620527c6-fe12-40f6-9fb8-0c387674d0bd"
  },
  {
    id: Id(),
    img:js,
    name:"Javascript",
    live:"https://res.cloudinary.com/defpepdn3/image/upload/v1686139229/logo/js_skxt5h.png"
  }
  ,
  {
    id: Id(),
    img:sql,
    name:"SQL",
    live:"https://res.cloudinary.com/defpepdn3/image/upload/v1686139230/logo/sql_n6tgjk.png",
  }
  ,
  {
    id: Id(),
    img:capstone,
    name:"Capstone Project",
    live:"https://www.credential.net/086cf264-121e-4569-802c-644cd4801850#gs.0icr6z"
  }
]

export default CertData;